import React, { useState } from "react";
import { auth } from "../../firebase/config";
import { signInWithEmailAndPassword, sendPasswordResetEmail } from "firebase/auth";
import { useNavigate } from "react-router-dom";

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [modoRecuperar, setModoRecuperar] = useState(false);
  const [enviado, setEnviado] = useState(false);
  const navigate = useNavigate();

  const inputStyle = {
    width: "100%", padding: "12px 16px", fontSize: "14px",
    border: "0.5px solid rgba(174, 182, 196, 0.3)",
    borderRadius: "8px", outline: "none",
    color: "#F3F5F7", background: "rgba(2, 11, 31, 0.6)",
    boxSizing: "border-box", fontFamily: "'Montserrat', sans-serif"
  };

  async function handleSubmit(e) {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await signInWithEmailAndPassword(auth, email, password);
      navigate("/dashboard");
    } catch (err) {
      setError("Correo o contraseña incorrectos");
    }
    setLoading(false);
  }

  async function handleRecuperar(e) {
    e.preventDefault();
    if (!email) { setError("Ingresá tu correo electrónico"); return; }
    setError("");
    setLoading(true);
    try {
      await sendPasswordResetEmail(auth, email);
      setEnviado(true);
    } catch (err) {
      setError("No encontramos una cuenta con ese correo");
    }
    setLoading(false);
  }

  return (
    <div style={{ minHeight: "100vh", background: "#020B1F", display: "flex", alignItems: "center", justifyContent: "center", fontFamily: "'Montserrat', sans-serif" }}>
      <div style={{ background: "rgba(39, 55, 80, 0.4)", borderRadius: "16px", padding: "48px 40px", width: "100%", maxWidth: "420px", boxShadow: "0 8px 32px rgba(0,0,0,0.4)", border: "0.5px solid rgba(174, 182, 196, 0.2)" }}>

        <div style={{ textAlign: "center", marginBottom: "40px" }}>
          <img src="/Logotipo-Deluxe.png" alt="Deluxe Software" style={{ height: "110px", width: "auto", marginBottom: "8px" }} />
          <div style={{ fontSize: "12px", color: "#AEB6C4", letterSpacing: "2px", marginTop: "12px" }}>GESTIÓN MÉDICA AVANZADA</div>
        </div>

        {!modoRecuperar ? (
          <form onSubmit={handleSubmit}>
            <div style={{ marginBottom: "16px" }}>
              <label style={{ fontSize: "11px", color: "#AEB6C4", display: "block", marginBottom: "6px", fontWeight: "500", letterSpacing: "1px" }}>CORREO ELECTRÓNICO</label>
              <input type="email" value={email} onChange={e => setEmail(e.target.value)} required placeholder="usuario@clinica.com" style={inputStyle} />
            </div>
            <div style={{ marginBottom: "12px" }}>
              <label style={{ fontSize: "11px", color: "#AEB6C4", display: "block", marginBottom: "6px", fontWeight: "500", letterSpacing: "1px" }}>CONTRASEÑA</label>
              <input type="password" value={password} onChange={e => setPassword(e.target.value)} required placeholder="••••••••" style={inputStyle} />
            </div>
            <div style={{ textAlign: "right", marginBottom: "20px" }}>
              <span onClick={() => { setModoRecuperar(true); setError(''); }} style={{ fontSize: "12px", color: "#00B8FF", cursor: "pointer" }}>
                ¿Olvidaste tu contraseña?
              </span>
            </div>
            {error && (
              <div style={{ background: "rgba(255, 59, 48, 0.15)", color: "#FF6B6B", fontSize: "13px", padding: "10px 14px", borderRadius: "8px", marginBottom: "16px", border: "0.5px solid rgba(255, 59, 48, 0.3)" }}>
                {error}
              </div>
            )}
            <button type="submit" disabled={loading} style={{ width: "100%", padding: "13px", fontSize: "13px", fontWeight: "600", background: loading ? "#273750" : "linear-gradient(135deg, #00B8FF, #0088CC)", color: "#FFFFFF", border: "none", borderRadius: "8px", cursor: loading ? "not-allowed" : "pointer", letterSpacing: "1px", fontFamily: "'Montserrat', sans-serif" }}>
              {loading ? "Ingresando..." : "INGRESAR"}
            </button>
            <div style={{ textAlign: "center", marginTop: "24px" }}>
              <span style={{ fontSize: '12px', color: 'rgba(174,182,196,0.5)' }}>¿No tenés cuenta? </span>
              <span onClick={() => navigate("/registro")} style={{ fontSize: '12px', color: '#00B8FF', cursor: 'pointer' }}>Registrate gratis</span>
            </div>
          </form>
        ) : (
          <div>
            {!enviado ? (
              <form onSubmit={handleRecuperar}>
                <div style={{ fontSize: "18px", fontWeight: "600", color: "#F3F5F7", marginBottom: "6px" }}>Recuperar contraseña</div>
                <div style={{ fontSize: "13px", color: "#AEB6C4", marginBottom: "24px" }}>Te enviamos un link para restablecer tu contraseña.</div>
                <div style={{ marginBottom: "20px" }}>
                  <label style={{ fontSize: "11px", color: "#AEB6C4", display: "block", marginBottom: "6px", fontWeight: "500", letterSpacing: "1px" }}>CORREO ELECTRÓNICO</label>
                  <input type="email" value={email} onChange={e => setEmail(e.target.value)} required placeholder="usuario@clinica.com" style={inputStyle} />
                </div>
                {error && (
                  <div style={{ background: "rgba(255, 59, 48, 0.15)", color: "#FF6B6B", fontSize: "13px", padding: "10px 14px", borderRadius: "8px", marginBottom: "16px", border: "0.5px solid rgba(255, 59, 48, 0.3)" }}>
                    {error}
                  </div>
                )}
                <div style={{ display: "flex", gap: "8px" }}>
                  <button type="button" onClick={() => { setModoRecuperar(false); setError(''); }} style={{ flex: 1, padding: "13px", fontSize: "13px", background: "transparent", border: "0.5px solid rgba(174,182,196,0.3)", borderRadius: "8px", color: "#AEB6C4", cursor: "pointer", fontFamily: "'Montserrat', sans-serif" }}>
                    Volver
                  </button>
                  <button type="submit" disabled={loading} style={{ flex: 2, padding: "13px", fontSize: "13px", fontWeight: "600", background: "linear-gradient(135deg, #00B8FF, #0088CC)", color: "#FFFFFF", border: "none", borderRadius: "8px", cursor: "pointer", fontFamily: "'Montserrat', sans-serif" }}>
                    {loading ? "Enviando..." : "Enviar link"}
                  </button>
                </div>
              </form>
            ) : (
              <div style={{ textAlign: "center" }}>
                <div style={{ fontSize: "48px", marginBottom: "16px" }}>📧</div>
                <div style={{ fontSize: "18px", fontWeight: "600", color: "#F3F5F7", marginBottom: "8px" }}>Revisá tu correo</div>
                <div style={{ fontSize: "13px", color: "#AEB6C4", marginBottom: "24px", lineHeight: "1.6" }}>Te enviamos un link para restablecer tu contraseña a <span style={{ color: "#00B8FF" }}>{email}</span></div>
                <button onClick={() => { setModoRecuperar(false); setEnviado(false); setEmail(''); }} style={{ width: "100%", padding: "13px", fontSize: "13px", fontWeight: "600", background: "linear-gradient(135deg, #00B8FF, #0088CC)", color: "#FFFFFF", border: "none", borderRadius: "8px", cursor: "pointer", fontFamily: "'Montserrat', sans-serif" }}>
                  Volver al login
                </button>
              </div>
            )}
          </div>
        )}

        <div style={{ textAlign: "center", marginTop: "24px", fontSize: "11px", color: "rgba(174, 182, 196, 0.3)", letterSpacing: "1px" }}>
          DELUXE SOFTWARE · Technology for Better Management
        </div>
      </div>
    </div>
  );
}